$(document).ready(function () {
    $('#notification-msg-container').on('click', '.close-msg', function () {
        var btn = $(this);
        var msgContainer = btn.closest('.msg-container');
        msgContainer.addClass('d-none');
    });
});